import { environment } from '../../../environments/environment';

export const ImageUrl = {

    CONTENT_IMAGE: `${environment.azureBlobStorage}/images/`,
    CONTENT_BIG_IMAGE: `${environment.azureBlobStorage}/images/`,
    PROFILE_IMAGES: `${environment.azureBlobStorage}`,
    LOGO_IMAGE: `${environment.azureBlobStorage}`,
};
